import MaterielBadges from './MaterielBadges';
import {
  activityFromItem,
  deviceTitle,
  typeLabel,
} from '../../materiels/materielDisplayMaps';

/**
 * En-tête fiche matériel — identité métier uniquement (pas de cloudSn).
 */
export default function MaterielDrawerHeader({ item, onClose }) {
  if (!item) return null;

  const title = deviceTitle(item);
  const typeUi = typeLabel(item.type);
  const sn = item.serialNumber ? String(item.serialNumber) : '—';
  const activity = activityFromItem(item);

  return (
    <header className="px-4 pt-4 pb-3 border-b border-gray-100 space-y-2">
      <div className="flex justify-between items-start gap-2">
        <div className="min-w-0">
          <p className="text-[11px] font-medium uppercase tracking-wide text-gray-400">
            Fiche matériel
          </p>
          <h2 className="font-semibold text-gray-900 text-sm truncate mt-0.5">
            {title}
          </h2>
          <p className="text-xs text-gray-500 mt-0.5 truncate">
            {typeUi} · N° série · {sn}
          </p>
        </div>
        <button
          type="button"
          onClick={onClose}
          className="text-xs text-gray-500 hover:text-gray-800 hover:underline shrink-0"
        >
          Fermer
        </button>
      </div>
      <MaterielBadges item={item} />
      <p className="text-xs text-gray-500 truncate">{activity}</p>
    </header>
  );
}
